import React from 'react';
import { PropTypes } from 'prop-types';

// eslint-disable-next-line import/prefer-default-export
export const NumberCellRenderer = ({ value }) => (
  <div>{ value != null ? value : 'N/A' }</div>
);

NumberCellRenderer.propTypes = {
  value: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string
  ])
};

NumberCellRenderer.defaultProps = {
  value: 'N/A'
};
